import React from 'react';
import { Zap, Download, MonitorPlay, Award, Users, ShieldCheck } from 'lucide-react';
import { motion } from 'framer-motion';

const Benefits = () => {
  return (
    <section className="py-20 relative overflow-hidden">
      
      
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-7xl pointer-events-none">
         <div className="absolute top-20 left-20 w-72 h-72 bg-primary/5 rounded-full blur-[100px]" />
         <div className="absolute bottom-20 right-20 w-72 h-72 bg-purple-500/5 rounded-full blur-[100px]" />
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        
        
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-5xl font-black text-slate-900 dark:text-white mb-6 tracking-tight">
            Una experiencia de aprendizaje <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-purple-600">
               sin interrupciones.
            </span>
          </h2>
          <p className="text-lg text-slate-600 dark:text-slate-400">
            Diseñamos Zento para que se sienta como tu plataforma de streaming favorita, pero enfocada en potenciar tu carrera.
          </p>
        </div>

        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          
          
          <motion.div 
            whileHover={{ y: -5 }}
            className="md:col-span-2 bg-slate-50 dark:bg-[#111] border border-slate-200 dark:border-white/10 rounded-3xl p-8 md:p-10 flex flex-col md:flex-row items-center gap-8 overflow-hidden relative group"
          >
            <div className="flex-1 relative z-10 text-center md:text-left">
               <div className="w-12 h-12 bg-orange-100 dark:bg-orange-500/20 text-orange-600 dark:text-orange-400 rounded-2xl flex items-center justify-center mb-6 mx-auto md:mx-0">
                  <Zap size={24} strokeWidth={2.5} />
               </div>
               <h3 className="text-2xl font-bold text-slate-900 dark:text-white mb-3">Sin relleno, directo al código.</h3>
               <p className="text-slate-600 dark:text-slate-400">
                 Olvídate de tutoriales de 30 minutos instalando programas. Aquí vamos directo a la práctica con rutas optimizadas.
               </p>
            </div>
           
            <div className="w-full md:w-1/2 bg-white dark:bg-black/40 rounded-xl p-4 border border-slate-200 dark:border-white/5 shadow-2xl transform rotate-3 group-hover:rotate-0 transition-transform duration-500">
               <div className="h-2 w-full bg-slate-200 dark:bg-white/10 rounded-full mb-3 overflow-hidden">
                  <div className="h-full bg-primary w-[70%]"></div>
               </div>
               <div className="flex gap-2">
                  <div className="h-2 w-10 bg-slate-200 dark:bg-white/10 rounded-full"></div>
                  <div className="h-2 w-20 bg-slate-200 dark:bg-white/10 rounded-full"></div>
               </div>
            </div>
          </motion.div>

          
          <motion.div 
            whileHover={{ y: -5 }}
            className="md:col-span-1 bg-primary text-white rounded-3xl p-8 md:p-10 flex flex-col justify-between overflow-hidden relative"
          >
            <div className="relative z-10">
               <div className="w-12 h-12 bg-white/20 backdrop-blur-md rounded-2xl flex items-center justify-center mb-6">
                  <Download size={24} strokeWidth={2.5} />
               </div>
               <h3 className="text-2xl font-bold mb-3">Modo Offline.</h3>
               <p className="text-white/80 text-sm">
                 Descarga tus clases y aprende en el metro, en el avión o donde no tengas señal.
               </p>
            </div>
            
            <Download className="absolute -bottom-6 -right-6 w-40 h-40 text-white/10 rotate-[-15deg]" />
          </motion.div>

          
          <motion.div 
            whileHover={{ y: -5 }}
            className="bg-slate-50 dark:bg-[#111] border border-slate-200 dark:border-white/10 rounded-3xl p-8 flex flex-col items-center text-center group"
          >
            <div className="w-14 h-14 bg-purple-100 dark:bg-purple-500/20 text-purple-600 dark:text-purple-400 rounded-full flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
               <MonitorPlay size={28} />
            </div>
            <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-2">Calidad 4K Streaming</h3>
            <p className="text-sm text-slate-600 dark:text-slate-400">
              Reproductor adaptable que consume pocos datos en móvil pero se ve cristalino en PC.
            </p>
          </motion.div>

          
          <motion.div 
            whileHover={{ y: -5 }}
            className="bg-slate-50 dark:bg-[#111] border border-slate-200 dark:border-white/10 rounded-3xl p-8 flex flex-col items-center text-center group"
          >
            <div className="w-14 h-14 bg-green-100 dark:bg-green-500/20 text-green-600 dark:text-green-400 rounded-full flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
               <Users size={28} />
            </div>
            <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-2">Comunidad Discord</h3>
            <p className="text-sm text-slate-600 dark:text-slate-400">
              No aprendas solo. Conéctate con mentores y otros estudiantes en tiempo real.
            </p>
          </motion.div>

          
          <motion.div 
             whileHover={{ y: -5 }}
             className="bg-slate-50 dark:bg-[#111] border border-slate-200 dark:border-white/10 rounded-3xl p-8 flex flex-col items-center text-center group"
          >
            <div className="w-14 h-14 bg-blue-100 dark:bg-blue-500/20 text-blue-600 dark:text-blue-400 rounded-full flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
               <Award size={28} />
            </div>
            <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-2">Certificados Verificados</h3>
            <p className="text-sm text-slate-600 dark:text-slate-400">
              Al terminar, recibe un diploma con ID único para agregar a tu LinkedIn.
            </p>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default Benefits;